import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
let serverUrl = getSecret('SERVER_URL');

export const mutations = {
  SET_TERRITORIES(state, value) {
    state.territories = value
  }
}

export const getters = {
  getTerritoryFields() {
    return {model: 'geographics_territory', 
            label: 'Territories',
            fields: [
              { key: 'name', label: 'Name', type: 'text', sortable: true, required: true },
              { key: 'municipalities', label: 'Municipalities', type: 'array_model', 
                model_source: 'Municipalities', model_route: 'management/masters/municipalities', 
                sortable: true, required: false, formatter: (value, key, item) => {
                return item.municipalities.length
              }}
            ]}
  },
  getTerritoriesLength(state) {
    return state.territories.length
  },
  getTerritories(state) {
    return state.territories
  }
}

export const actions = {
  async fetchTerritories({commit, state}, query = '') {
    return axios
      .get(`${serverUrl}/api/masters/territories/${query}`)
      .then((response) => {
        commit('SET_TERRITORIES', response.data)
        return response.data;
      })
  },

  async createTerritories(context, { payload }) {
    return axios
      .post(`${serverUrl}/api/masters/territories/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async updateTerritories(context, { payload }) {
    return axios
      .patch(`${serverUrl}/api/masters/territories/${payload.id}/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async deleteTerritories(context, { id }) {
    return axios
      .delete(`${serverUrl}/api/masters/territories/${id}/`)
      .then((response) => {
        return response.data;
      })
  }
}